/**
 * Mount Shop Pay, Google Pay, and other accelerated checkout buttons
 * below PageFly product Buy Now buttons.
 */
(function () {
  const PF_FORM_SELECTOR = 'form.pf-product-form:has([data-pf-type="ProductATC2"])';
  const ATC_SELECTOR = '[data-pf-type="ProductATC2"]';

  function initPaymentButtons() {
    if (!window.Shopify || !window.Shopify.PaymentButton) return false;
    try {
      window.Shopify.PaymentButton.init();
      return true;
    } catch (error) {
      return false;
    }
  }

  function waitForPaymentButtons(callback) {
    let attempts = 0;

    const tick = function () {
      attempts += 1;
      if (initPaymentButtons() || attempts >= 40) {
        callback();
        return;
      }
      window.setTimeout(tick, 150);
    };

    tick();
  }

  function getVariantId(pfForm) {
    const productBox = pfForm.closest('[data-pf-type="ProductBox"]');
    const fromBox = productBox && productBox.getAttribute('data-default-variant');
    if (fromBox) return fromBox;

    const idInput = pfForm.querySelector('input[name="id"]');
    return idInput ? idInput.value : null;
  }

  function ensureVariantInput(pfForm) {
    let idInput = pfForm.querySelector('input[name="id"]');
    const variantId = getVariantId(pfForm);

    if (!variantId) return null;

    if (!idInput) {
      idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      pfForm.prepend(idInput);
    }

    idInput.value = variantId;
    return idInput;
  }

  function syncVariant(pfForm) {
    const variantId = getVariantId(pfForm);
    const idInput = pfForm.querySelector('input[name="id"]');
    if (variantId && idInput && idInput.value !== variantId) {
      idInput.value = variantId;
      initPaymentButtons();
    }
  }

  function watchVariant(pfForm, productBox) {
    if (!productBox || productBox.dataset.ssWalletsVariantWatch === '1') return;
    productBox.dataset.ssWalletsVariantWatch = '1';

    new MutationObserver(function () {
      syncVariant(pfForm);
    }).observe(productBox, {
      attributes: true,
      attributeFilter: ['data-default-variant'],
    });
  }

  function mountForForm(pfForm) {
    if (!pfForm || pfForm.dataset.ssWalletsMounted === '1') return;

    const atc = pfForm.querySelector(ATC_SELECTOR);
    const sourceSlot = document.querySelector('[data-ss-pf-wallets-slot]');
    if (!atc || !sourceSlot || !sourceSlot.children.length) return;

    ensureVariantInput(pfForm);

    const mount = document.createElement('div');
    mount.className = 'ss-pf-wallets';
    mount.setAttribute('data-ss-pf-wallets', '');

    const label = document.createElement('p');
    label.className = 'ss-pf-wallets__label';
    label.textContent = 'Or pay with';
    mount.appendChild(label);

    while (sourceSlot.firstChild) {
      mount.appendChild(sourceSlot.firstChild);
    }

    atc.insertAdjacentElement('afterend', mount);
    pfForm.dataset.ssWalletsMounted = '1';

    const productBox = pfForm.closest('[data-pf-type="ProductBox"]');
    watchVariant(pfForm, productBox);
    waitForPaymentButtons(function () {});
  }

  function init() {
    document.querySelectorAll(PF_FORM_SELECTOR).forEach(mountForForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const root = document.querySelector('.__pf') || document.body;
  new MutationObserver(init).observe(root, { childList: true, subtree: true });
})();
